import {Service} from '../service/service.js';
import {DataManagementService} from '../service/datamanagement/dataManagementService.js';
import {ElementUtil} from './elementUtil.js';
import {TimeUtil} from './timeUtil.js';
import {SessionStorageUtil} from './browserStorageSanitizer.js';

export var ImportUtil = {

	isGpsImportDataType(dataType) {
		return dataType === 'GPS' || dataType === 'GPS_FUEL';
	},

	systemDefaultAutoUnitAppliesToDataTypes(dataTypes) {
		if (!dataTypes) {
			return false;
		}
		var importUtil = this;
		var types = String(dataTypes).split(',').map(function(type) {
			return type.trim();
		}).filter(function(type) {
			return type.length > 0;
		});
		if (types.length === 0) {
			return false;
		}
		return types.every(function(type) {
			return importUtil.isGpsImportDataType(type);
		});
	},

	defaultAutoUnitIdForDataTypes(dataTypes) {
		return this.systemDefaultAutoUnitAppliesToDataTypes(dataTypes) ? null : 'NO_AUTO_UNIT';
	},

	autoUnitPlaceholderForDataTypes(dataTypes) {
		return this.systemDefaultAutoUnitAppliesToDataTypes(dataTypes)
			? 'System Default - Auto Tractors'
			: 'No Auto Unit Creation';
	},

	formatAutoUnitLabel(autoUnitId, dataType) {
		if (autoUnitId === 'NO_AUTO_UNIT') {
			return 'No Auto Unit Creation';
		}
		if (!autoUnitId) {
			if (dataType && this.isGpsImportDataType(dataType)) {
				return 'System Default - Auto Tractors';
			}
			return 'No Auto Unit Creation';
		}
		return autoUnitId;
	},

	selectionIncludesGpsImport(records) {
		if (!records || records.length === 0) {
			return false;
		}
		var importUtil = this;
		return records.some(function(record) {
			return importUtil.isGpsImportDataType(record.dataType);
		});
	},

	buildReprocessOptions(formData, record) {
		var options = Object.assign({}, formData);
		if (!this.isGpsImportDataType(record.dataType)) {
			delete options.gpsFilterId;
			delete options.gpsFilteringOff;
		}
		return options;
	},

	resolveReprocessSavedOptions(records) {
		if (!records || records.length === 0) {
			return { options: null, optionsDiffer: false };
		}
		var baseline = records[0].options || null;
		if (records.length === 1) {
			return { options: baseline, optionsDiffer: false };
		}
		var baselineJson = JSON.stringify(baseline);
		var optionsDiffer = records.some(function(record) {
			return JSON.stringify(record.options || null) !== baselineJson;
		});
		return { options: baseline, optionsDiffer: optionsDiffer };
	},
		
	showUpload(options) {
		var importUtil = this;
		
		var uploadWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Upload',
			icon: 'vaadin:upload',
			width: (options.hideOptions ? 500 : .75),
			height: (options.hideOptions ? 350 : .75),
			fitContent: !options.hideOptions,
			listeners: {
				ready: function () {
					uploadWin.show();

					//form with options
					var uploadHandler = function () {

						if (uploadFormPanel.isValid()) {
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('An import file is required.');
							} else {
								uploadField.uploadFiles();
							}
						}

					};

					var refitUploadDialog = function () {
						if (uploadWin.refitToContent) {
							uploadWin.refitToContent();
						}
					};
					
					var optionFormConfig = {
						tag: 'dl-import-option-form',
						properties: {}
					};
					if (options.showGPSFilter) {
						optionFormConfig.properties.showGPSFilter = options.showGPSFilter;
					}
					if (options.visibleOptions) {
						optionFormConfig.properties.visibleOptions = options.visibleOptions;
					}
					if (options.dataTypes) {
						optionFormConfig.properties.dataTypes = options.dataTypes;
					}
					
					var uploadFormPanel = ElementUtil.create({
						tag: 'dl-form-panel',
						itemid: 'form',
						children: [
							{
								tag: 'vaadin-form-layout',
								children: [
									{
										tag: 'vaadin-combo-box',
										name: 'dataHandlerId',
										label: 'Data Format',
										'item-value-path': 'handlerId',
										'item-label-path': 'description',
										required: true,
										postinit: function (combo) {
											DataManagementService.getDataHandlerService().getCompanyDataHandler(options.dataTypes).then(function (data) {
												var formats = data || [];
												formats.sort(function (a, b) {
													var descriptionA = (a.description || '').toLowerCase();
													var descriptionB = (b.description || '').toLowerCase();
													return descriptionA.localeCompare(descriptionB);
												});
												combo.items = formats;
											});
										},
										listeners: {
											change: function(event) {
												var formatDetails = ElementUtil.query(uploadFormPanel, 'formatDetails');
												var selectedItem = event.target.selectedItem;
												if (selectedItem) {
													formatDetails.innerHTML = selectedItem.formatDescription || '';
												} else {
													formatDetails.innerHTML = '';
												}
												refitUploadDialog();
											}
										},
										placeHolder: 'Select'
									},
									{
										tag: 'vaadin-upload',
										itemid: 'uploadField',
										'no-auto': true,
										'max-files': 1,
										required: true,
										target: options.uploadUrl,
										headers: importUtil.getUploadHeader(),
										listeners: {
											'upload-request': function (event) {
												var data = uploadFormPanel.getData();
												event.detail.formData.append('options', JSON.stringify(data));
											},
											'upload-success': function (event) {
												var responseData = JSON.parse(event.detail.xhr.responseText);
												if (responseData.uploadFile) {
													//error 
													window.DL.MessageUtil.showOkMessage(
															responseData.uploadFile + '<br>' +
															responseData.uploadFileType ? responseData.uploadFileType : ''
															);

													if (options.failCallback){
														options.failCallback(responseData);
													}		
												} else {
													window.DL.MessageUtil.showToast('Success', 'Uploaded Successfully.<br>The import will be processed on Task queue.', {
														theme: 'success',
														position: 'top-stretch'
													});
													
													if (options.successCallback){
														options.successCallback(responseData);
													}
													uploadWin.close();
												}
											}
										}
									}
								]
							},
							{
								tag: 'vaadin-details',
								summary: 'Format Details',
								listeners: {
									'opened-changed': function () {
										refitUploadDialog();
									}
								},
								children: [
									{
										tag: 'div',
										itemid: 'formatDetails',
										style: 'max-height:320px;overflow:auto;'
									}
								]
							},
							{
								tag: 'vaadin-details',
								'class': (options.hideOptions ? 'hide' : ''),
								summary: 'Advanced Options',
								properties: {
									opened: false
								},
								listeners: {
									'opened-changed': function () {
										refitUploadDialog();
									}
								},
								children: [
									optionFormConfig
								]
							},
							{
								tag: 'vaadin-form-layout',
								children: [
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:upload', ' Upload')
												],
												listeners: {
													click: function () {
														if (uploadFormPanel.isValid()) {
															uploadHandler();
														}
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function () {
														uploadWin.close();
													}
												}
											}
										]
									}
								]
							}
						]
					});
					uploadWin.addToContentElement(uploadFormPanel);

				}
			}
		});
	},
	
	getUploadHeader() {		
		var companyHeaders = '{}';
		var workingCompanyId = SessionStorageUtil.getItem('workingCompany');
		if (workingCompanyId) {
			companyHeaders = '{ "Company": "' + workingCompanyId + '"}';
		}	
		return companyHeaders;
	}
	
};

